(() => {
  function init(scope = document) {
    for (const gallery of scope.querySelectorAll('[data-frame-gallery]')) {
      if (gallery.dataset.ready) continue;
      gallery.dataset.ready = 'true';
      const hero = gallery.querySelector('[data-gallery-image]');
      const link = gallery.querySelector('[data-gallery-open]');
      const caption = gallery.querySelector('[data-gallery-caption]');
      const dialog = gallery.querySelector('dialog');
      let opener;
      function select(thumb) {
        hero.removeAttribute('srcset');
        hero.src = thumb.dataset.image;
        hero.alt = thumb.dataset.caption;
        link.href = thumb.href;
        caption.textContent = thumb.dataset.caption;
        for (const item of gallery.querySelectorAll('[data-gallery-thumb]')) item.setAttribute('aria-current', String(item === thumb));
      }
      gallery.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) { event.preventDefault(); select(thumb); return; }
        if (!event.target.closest('[data-gallery-open]')) return;
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        opener = document.activeElement;
        const full = dialog.querySelector('[data-gallery-full]');
        full.src = link.href; full.alt = hero.alt;
        dialog.querySelector('[data-gallery-full-caption]').textContent = caption.textContent;
        dialog.showModal();
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
      gallery.addEventListener('bae:color', event => {
        const color = String(event.detail || '').toLowerCase();
        const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
        const thumb = thumbs.find(item => {
          const label = item.dataset.caption.toLowerCase();
          if (color.includes('teal')) return label.includes('teal');
          if (color === 'gris y blanco') return label.includes('cuadro mr1 gris y blanco');
          if (color.includes('blanco')) return label.includes('blanco') && !label.includes('negro');
          if (color.includes('negro')) return label.includes('negro') && !label.includes('blanco');
          return false;
        });
        if (thumb) select(thumb);
      });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
